/**
=========================================================
* Clifford Inu
=========================================================
*/

// Material Dashboard 2 PRO React Base Styles
import colors from "assets/theme/base/colors";

const { transparent } = colors;

export default {
  styleOverrides: {
    root: {
      backgroundColor: transparent.main,
    },
  },
};
